<cue-gallery
  [items]="computedFiles()"
  [openedItem]="computedSelectedFile()"
  (openedItemChange)="onOpenedChanges($event)"
/>
@if (hasAnyFile()) {
  <div class="gallery">
    <div class="gallery-inner">
      @for (file of computedFiles(); track file.uniqueIdentifier) {
        <div
          class="gallery-thumb-wrapper ring-offset-1"
          [attr.data-cy]="'navigation-gallery-item-' + file.type + '-' + file.uniqueIdentifier"
          (click)="selectedFile.set(file.originalFile)"
          [ngClass]="file.imageClass"
          [class.ring]="selectedFile() === file.originalFile"
        >
          @if (!file.isVideo) {
            @if (file.isMatterport) {
              <div class="gallery-thumb-overlay">
                <cue-icon [icon]="ICONS.cuePanorama" />
                <span class="text">{{ translation.navigation.interactiveView | transloco }}</span>
              </div>
            }
            <cue-image
              [preventContextMenu]="true"
              [objectPosition]="file.imageObjectPosition"
              class="gallery-thumb"
              [ngClass]="file.imageClass"
              [src]="file.src"
              [imgMaxWidth]="'auto'"
              [imgHeight]="'100%'"
              (click)="selectedFile.set(file.originalFile)"
            />
          } @else {
            <div class="gallery-thumb-overlay gallery-thumb-overlay--video">
              <cue-icon [icon]="ICONS.cuePlayFill" />
            </div>
            <video
              class="gallery-thumb ring-offset-1"
              preload="metadata"
              [src]="file.src"
              (click)="selectedFile.set(file.originalFile)"
            ></video>
          }
        </div>
      }
    </div>
  </div>
}
